export default __webpack_public_path__ + "static/media/c-role.2f2bd92d.svg";